import { createPlugin } from '@backstage/core-plugin-api';

import { searchRouteRef } from './routes';

export const customSearchUiPlugin = createPlugin({
  id: 'custom-search-ui',
  externalRoutes: {
    search: searchRouteRef,
  },
});

export { CustomSidebarSearchModal } from './components/CustomSidebarSearchModal';
export { CustomSearchModal } from './components/CustomSearchModal';
